<template>
  <div class="consult_warp">
    <FDBannerImg />
    <div class="consult_container">
      <div class="titleBox">
        <div class="title">常见问题</div>
        <div class="info">
          本系统收录了有关复旦大学管理学院图书馆各类读者服务、资源使用、学位论文写作等方面的常见问题，读者可以检索或浏览相关问题得到解答。
        </div>
      </div>
      <div class="navBar barColor">
        <el-select v-model="searchType" size="small" class="select_box">
          <el-option
            v-for="item in searchOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <input
          class="searchInput"
          placeholder="请输入问题的关键词（尽可能简短，不超过5个字，长句及标点可能会影响检索效果）"
          v-model="searchValue"
          @keyup.enter="onSearch"
        />
        <div class="searchBtn" @click="onSearch">Search</div>
        <!-- <div class="browse">
          <span>浏览：</span>
          <a
            @click="reset"
            href="javaScript:;"
            target="_self"
            class="all_question"
            >全部问题</a
          >
          <Dropdown size="small" trigger="click" placement="bottom-start">
            <span class="el-dropdown-link">
              关键词<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <DropdownMenu slot="dropdown">
              <DropdownItem>借阅相关</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div> -->
      </div>
      <h2 v-if="searchResult">
        检索结果: <i>{{ searchValue }}</i>
      </h2>
      <h2 v-else>所有结果:</h2>
      <div class="sort">
        <div
          class="sortBtn"
          :class="sortBy == 'search_num' ? 'active' : ''"
          @click="changeSort('search_num', 'common')"
        >
          精选问题
        </div>
        <div
          class="sortBtn"
          :class="sortBy == 'update_by' ? 'active' : ''"
          @click="changeSort('update_by', '')"
        >
          所有问题
        </div>
      </div>

      <div class="searchBox">
        <div class="navTitle barColor">检索结果 Search Results</div>

        <div class="contentBox">
          <div class="leftBox">
            <div class="filterBox" v-if="topicIds.length || keywordIds.length">
              <b>当前过滤条件</b>

              <div class="filter_topic" v-if="topicIds.length">
                常用主题：<Tag
                  v-for="id in topicIds"
                  :key="id"
                  closable
                  size="mini"
                  type="info"
                  effect="dark"
                  style="margin-right: 8px"
                  @close="delTopic(id)"
                >
                  {{ getNameById(id) }}
                </Tag>
              </div>

              <!-- <div class="filter_keyword" v-if="keywordIds.length">
                常用关键词：<Tag
                  v-for="id in keywordIds"
                  :key="id"
                  closable
                  size="mini"
                  type="info"
                  effect="dark"
                  style="margin-right: 8px"
                  @close="delKeyword(id)"
                >
                  {{ getNameById(id) }}
                </Tag>
              </div> -->
            </div>

            <div class="page">
              <Pagination
                v-if="total > 0"
                small
                background
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                layout="total, prev, pager, next"
                :total="total"
              />
            </div>

            <div class="contentList">
              <div class="listItem" v-for="item in dataList" :key="item.id">
                <div @click="toDetail(item)" class="result_title">
                  {{ item.title }}
                </div>

                <div class="result_info">
                  <div class="updateTime">
                    <b>最后更新时间</b>
                    {{ item.time }} |
                  </div>
                  <div class="subjects">
                    <b>主题</b>
                    <div
                      @click="selectTag(i, 'topic')"
                      class="tag"
                      v-for="i in item.topicLabels"
                    >
                      {{ i }}
                    </div>
                  </div>

                  <div class="keywords">
                    <span style="margin: 0 10px">|</span><b>关键词</b>
                    <div
                      @click="selectTag(i, 'keyword')"
                      class="tag"
                      v-for="i in item.keywordLabels"
                    >
                      {{ i }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="page">
              <Pagination
                v-if="total > 20"
                small
                background
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                layout="total, prev, pager, next"
                :total="total"
              />
            </div>
          </div>
          <div class="rightBox">
            <div class="treebox">
              <div class="treeTitle">常用主题</div>
              <Tree
                ref="topTree"
                :data="currentToplist"
                show-checkbox
                node-key="id"
                default-expand-all
                :props="propsOption"
                :check-strictly="true"
                :expand-on-click-node="false"
                :check-on-click-node="true"
                @check-change="topTreeClick"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span>{{ data.name }}</span>
                  <span v-if="data.num"> ({{ data.num }})</span>
                </span>
              </Tree>
              <template v-if="topList.length > showLength">
                <div class="more_box" @click="getMore" v-if="!isMore">
                  展示更多<i class="el-icon-d-arrow-right"></i>
                </div>
                <div class="more_box" @click="getClose" v-else>
                  收起 <i class="el-icon-d-arrow-right rotate"></i>
                </div>
              </template>
            </div>
            <!-- <div class="treebox">
              <div class="treeTitle">常用关键词</div>
              <Tree
                ref="keyTree"
                :data="keyList"
                show-checkbox
                node-key="id"
                default-expand-all
                :props="propsOption"
                :check-strictly="true"
                :expand-on-click-node="false"
                :check-on-click-node="true"
                @check-change="keyTreeClick"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span>{{ data.name }}</span>
                  <span v-if="data.num"> ({{ data.num }})</span>
                </span>
              </Tree>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Pagination,
  Tree,
  Tag,
} from "element-ui";
import { post, get } from "@u/request";
import FDBannerImg from "@c/FDBannerImg";
export default {
  name: "",
  components: {
    FDBannerImg,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Pagination,
    Tree,
    Tag,
  },
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      dataList: [],
      keyList: [],
      topList: [],
      filterList: [],
      propsOption: {
        label: "name",
      },
      sortBy: "search_num",
      searchValue: null,
      searchResult: false,
      topicIds: [],
      keywordIds: [],
      searchType: "0",
      searchOptions: [
        { label: "全部", value: "0" },
        { label: "题名", value: "1" },
        { label: "关键词", value: "2" },
      ],
      currentToplist: [],
      isMore: false,
      showLength: 10,
      type: "common",
    };
  },
  computed: {},
  methods: {
    getMore() {
      this.isMore = true;
      this.currentToplist = this.topList;
    },
    getClose() {
      this.currentToplist = this.topList.slice(0, this.showLength);
      this.isMore = false;
    },
    getNameById(id) {
      return this.filterList.filter((o) => o.id == id)[0].name;
    },
    topTreeClick(data) {
      const arr = this.$refs.topTree.getCheckedNodes();
      this.topicIds = arr.map((item) => item.id);
      this.loadList();
    },
    keyTreeClick(data) {
      const arr = this.$refs.keyTree.getCheckedNodes();
      this.keywordIds = arr.map((item) => item.id);
      this.loadList();
    },
    handleCurrentChange() {
      this.loadList();
    },
    changeSort(sort, type) {
      this.sortBy = sort;
      this.type = type;
      this.loadList();
      this.groupByNum();
    },
    onSearch() {
      if (this.searchValue) {
        this.$router.push(`/consult?searchValue=${this.searchValue}`);
      } else {
        this.$router.push(`/consult`);
      }
      this.loadList();
      this.groupByNum();
    },

    async groupByNum() {
      const params = {
        sortBy: this.sortBy,
        searchValue: this.searchValue,
        topicIds: this.topicIds,
        searchType: this.searchType,
        type: this.type,
      };
      const { data } = await post(
        "lib/question/pc/list/groupByNum",
        params
      ).catch(() => {});
      this.topList = this.handleTree(data, "id", "pid");
      this.getClose();
    },
    reset() {
      this.$router.push(`/consult`);
      this.searchValue = null;
      this.$refs.topTree.setCheckedKeys([]);
      this.$refs.keyTree.setCheckedKeys([]);
      this.topicIds = [];
      this.keywordIds = [];
      this.loadList();
    },
    delTopic(id) {
      this.topicIds = this.topicIds.filter((o) => o != id);
      this.$refs.topTree.setCheckedKeys(this.topicIds);
    },
    delKeyword(id) {
      this.keywordIds = this.keywordIds.filter((o) => o != id);
      this.$refs.keyTree.setCheckedKeys(this.keywordIds);
    },
    selectTag(i, type) {
      const id = this.filterList.filter((o) => o.name == i)[0].id;
      if (type == "topic") {
        this.topicIds = [id];
        this.$refs.topTree.setCheckedKeys(this.topicIds);
      } else {
        this.keywordIds = [id];
        this.$refs.keyTree.setCheckedKeys(this.keywordIds);
      }
    },
    async loadList() {
      this.searchResult = this.searchValue ? true : false;
      const data = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        sortBy: this.sortBy,
        searchValue: this.searchValue,
        topicIds: this.topicIds,
        keywordIds: this.keywordIds,
        searchType: this.searchType,
        type: this.type,
      };
      const { rows, total } = await post("lib/question/pc/list", data).catch(
        () => {}
      );
      this.dataList = rows.map((item) => {
        const time = item.updateTime || item.createTime;
        item.time = time.split(" ")[0];
        return item;
      });
      this.total = total;
    },
    async getTopicTree() {
      const { data } = await get("lib/common/tok/list", {
        type: "topic",
      }).catch(() => {});
      this.topList = this.handleTree(data, "id", "pid");
      this.getClose();
    },
    async getKeywordTree() {
      const { data } = await get("lib/common/tok/list", {
        type: "keyword",
      }).catch(() => {});
      this.keyList = this.handleTree(data, "id", "pid");
    },
    async getFilterList() {
      const { data } = await get("lib/common/tok/list").catch(() => {});
      this.filterList = data;
    },
    toDetail(item) {
      this.$router.push(`/consult/detail/${item.id}`);
    },
  },
  mounted() {
    this.loadList();
    this.getFilterList();
    this.groupByNum();
    // this.getKeywordTree();
  },
  created() {
    this.searchValue = this.$route.query.searchValue;
  },
};
</script>

<style scoped lang="scss">
.el-dropdown-link {
  cursor: pointer;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.consult_warp {
  .barColor {
    background-image: linear-gradient(to bottom, #f5f5f5 0, #ebebeb 100%);
    background-color: #f0f0f0;
  }
  .footer {
    height: 62px;
    max-width: 1170px;
    padding: 5px 0;
    margin: 0 auto;
    border-top: 1px solid #ccc;
    text-align: center;
    font-size: 12px;
    a {
      text-decoration: underline;
      color: #2f6fa7;
    }
  }
  .consult_container {
    max-width: 1170px;
    padding: 0;
    margin: 0 auto;
    h2 {
      font-weight: 700;
      font-size: 16px;
      margin: 20px 0;
    }
    .top {
      padding: 8px 15px;
      font-size: 14px;

      a {
        text-decoration: underline;
        color: #2f6fa7;
      }
    }
    .titleBox {
      padding: 40px 0 20px;
      text-align: center;
      .title {
        font-size: 36px;
        line-height: 1.1;
      }
      .info {
        font-size: 14px;
        margin-bottom: 20px;
        margin-top: 10px;
      }
    }
    .navBar {
      width: 100%;
      display: flex;
      align-items: center;
      border: 1px solid #ccc;
      min-height: 52px;
      margin-bottom: 10px;
      border-radius: 4px;
      font-size: 14px;
      padding-left: 20px;
      .nav_total {
        height: 100%;
        width: 100px;
        line-height: 52px;
        color: #777;
        font-size: 14px;
        text-align: center;
        font-weight: 700;
      }
      .select_box {
        width: 120px;
        ::v-deep {
          .el-input__inner {
            border: 1px solid #ccc;
            height: 34px;
            line-height: 34px;
            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
            border-radius: 4px 0 0 4px;
            border-right: 0;
          }
        }
      }
      .searchInput {
        margin: 8px 0 8px 0px;
        height: 34px;
        width: 550px;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857143;
        color: #555;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        outline: none;
        border-radius: 0 4px 4px 0;
      }
      .searchInput:focus {
        border-color: #409eff;
      }
      input::-webkit-input-placeholder,
      textarea::-webkit-input-placeholder {
        color: #969696;
      }
      .searchBtn {
        cursor: pointer;
        height: 34px;
        padding: 6px 12px;
        margin: 8px 30px 8px 20px;
        background-color: #494949;
        color: #fff;
        border-radius: 4px;
      }
      .searchBtn:hover {
        background-color: #555;
      }
      .browse {
        border: 1px solid #ccc;
        border-radius: 4px;
        background-color: #fff;
        margin: 8px 20px;
        margin-left: auto;
        color: #454545;
        font-weight: 700;
        line-height: 34px;
        padding: 0 20px;
        .all_question {
          color: #454545;
          padding: 0 20px;
        }
        .all_question:hover {
          text-decoration: underline;
        }
      }
    }
    .sort {
      display: flex;
      .sortBtn {
        cursor: pointer;
        font-size: 16px;
        color: #337ab7;
        border-bottom: 2px solid #337ab7;
        padding: 5px 20px;
        margin-right: 20px;
      }
      .sortBtn:hover {
        background-color: #e6e6e6;
      }
      .active {
        border-width: 4px !important;
      }
    }
    .searchBox {
      border: 1px solid #ccc;
      margin: 20px 0 30px;
      .navTitle {
        width: 100%;
        padding: 10px;
        font-size: 14px;
        border-bottom: 1px solid #ccc;
      }
      .contentBox {
        display: flex;
        margin: 10px 0;
        padding: 0 20px;
        .leftBox {
          flex: 3;
          margin-right: 30px;
          .filterBox {
            position: relative;
            background-color: #efefef;
            margin: 10px 0 20px;
            padding: 6px;
            border-radius: 5px;
            font-size: 14px;
            .filter_topic,
            .filter_keyword {
              display: inline-block;
              margin-left: 20px;
            }
          }
          .page {
            margin: 10px 0 15px;
          }
          .contentList {
            margin-top: 10px;
            .listItem {
              margin-bottom: 10px;
              padding-bottom: 10px;
              border-bottom: 1px solid #efefef;
              position: relative;
              font-size: 12px;
              .result_title {
                cursor: pointer;
                display: inline-block;
                font-size: 14px;
                font-weight: 700;
                color: #2f6fa7;
                text-decoration: underline;
              }
              .result_title:hover {
                color: #23527c;
              }
              .result_info {
                display: flex;
                padding: 6px 0;
                .updateTime {
                  padding-right: 6px;
                }
              }
            }
          }
        }
        .rightBox {
          flex: 1;
          padding-top: 20px;
          font-size: 14px;
          .treebox {
            margin-bottom: 20px;
            .treeTitle {
              padding: 8px 10px;
              border-bottom: 1px solid #ccc;
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
  .more_box {
    text-align: center;
    cursor: pointer;
    margin-top: 10px;
    color: #999;
    .el-icon-d-arrow-right {
      transform: rotate(90deg);
    }
    .rotate {
      transform: rotate(-90deg);
    }
  }
  .tag {
    cursor: pointer;
    display: inline-block;
    color: #524f4f;
    background-color: #d3d6dc;
    text-decoration: underline;
    font-weight: 700;
    padding: 3px 5px 4px;
    margin-left: 10px;
    border-radius: 2px;
    line-height: 1;
  }
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #333;
  border-color: #fff;
}
::v-deep .el-checkbox__inner {
  border: 1px solid #000;
}

::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
  border: 1px solid #000;
}

::v-deep .el-tree-node__content {
  font-weight: 700;
  color: #333;
  margin: 1px 0;
}
</style>
